import { Property } from '../../types/property';

export const SORT_OPTIONS: { value: string; label: string }[] = [
  { value: 'default', label: 'Default' },
  { value: 'price-asc', label: 'Price: Low to High' },
  { value: 'price-desc', label: 'Price: High to Low' },
  { value: 'beds-asc', label: 'Beds: Low to High' },
  { value: 'beds-desc', label: 'Beds: High to Low' },
  { value: 'alphabetical', label: 'Alphabetical' },
];

export const isSaleAgreed = (p: Property) => p.status?.key === 'saleAgreed';

export const sortProperties = (properties: Property[], sort: string): Property[] => {
  const active = properties.filter((p) => !isSaleAgreed(p));
  const agreed = properties.filter(isSaleAgreed);

  const sorted = [...active].sort((a, b) => {
    switch (sort) {
      case 'price-asc':
        return (a.price?.price ?? a.price?.minPrice ?? 0) - (b.price?.price ?? b.price?.minPrice ?? 0);
      case 'price-desc':
        return (b.price?.price ?? b.price?.minPrice ?? 0) - (a.price?.price ?? a.price?.minPrice ?? 0);
      case 'beds-asc':
        return (a.numBedrooms ?? 0) - (b.numBedrooms ?? 0);
      case 'beds-desc':
        return (b.numBedrooms ?? 0) - (a.numBedrooms ?? 0);
      case 'alphabetical':
        return (a.displayAddress ?? '').localeCompare(b.displayAddress ?? '');
      default:
        return 0;
    }
  });

  return [...sorted, ...agreed];
};
